import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { userInfoApi } from "@/api/admin";
import { useStore } from "@/store/user";
import loginVue from '@/views/admin/login.vue'
import registerVue from "@/views/admin/register.vue";
import { ElMessage } from "element-plus";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/index',  // 将根路径重定向到 /index
  },
  {
    path: '/login',
    name: 'login',
    component: loginVue
  },
  {
    path: '/register',
    name: 'register',
    component: registerVue, 
  },
  {
    path: '/',
    name: 'home',
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: 'index',
        component: () => import("../views/statistics/index.vue")
      },
      {
        path: 'OlympiadQuestionBankManagement',
        component:()=> import("../views/olympiad/questionBank.vue")
      },
      {
        path: 'OlympiadAllquestionRouting',
        component:()=> import("../views/olympiad/olympiadAllQuestion.vue")
      },
      {
        path: 'UGC-QuestionBank',
        component:()=> import("../views/UGC/ugcBank.vue")
      },
      {
        path:'UGCAllquestion',
        component:()=> import("../views/UGC/all.vue")
      },
      {
        path: 'userManagement',
        component:()=> import("../views/user/userManagementList.vue")
      },
      {
        path:'userLog',
        component:()=>import("../views/user/log.vue")
      },
      {
        path: 'save',
        component:()=> import("../views/classify/save.vue")
      },
      {
        path: 'list',
        component:()=> import("../views/classify/xcx.vue")
      },
      {
        path: 'inviteCode',
        component:()=> import("../views/user/InviteCode.vue")
      },
      {
        path: 'sta',
        component:()=> import("../views/classify/Dashboard.vue")
      },
      {
        path: 'sta2',
        component:()=> import("../views/classify/sta2.vue")
      },
      {
        path: 'Admin',
        component:()=> import("../views/admin/list.vue"),
        meta: {
          requiresAdmin: true
        }
      },
      {
        path: 'SuperAdmin',
        component:()=> import("../views/admin/superList.vue"),
        meta: {
          requiresSuperAdmin: true
        }
      },
      {
        path: 'allAdmin',
        component:()=> import("../views/admin/AdminList.vue")
      },
      {
        path: 'Books',
        component:()=> import("../views/UGC/books.vue")
      },

    ]
  }

]

const router = createRouter({
  history: createWebHashHistory(),  
  routes
})

/**
 * 路由守卫
 * 通过发请求，获取用户信息
 * 判断是否登录
 */
router.beforeEach(async (to, from, next) => {
  const store = useStore()
  const token = localStorage.getItem("token")

  // 1. 无token重定向
  if (!token && !['/login', '/register'].includes(to.path)) {
    ElMessage.error("请先登录")
    return next('/login')
  }

  // 2. 有token时验证用户信息
  if (token) {
    try {
      // 强制刷新用户信息
      const res = await userInfoApi()
      // console.log('用户信息:', res.data)
      
      if (res.code === 20000) {
        store.setUserInfo({
          username: res.data.userInfo.username,
          role: res.data.userInfo.role,
          avatar: res.data.userInfo.avatar
        })
      } else {
        throw new Error(res.message || '获取用户信息失败')
      }
    } catch (error) {
      console.error('用户信息验证失败:', error)
      store.clearUser()
      return next('/login')
    }
  }

  // 3. 权限验证
  if (to.meta.requiresSuperAdmin && !store.isSuperAdmin) {
    ElMessage.error("权限不足")
    return next(from.path || '/index')
  }

  next()
})

// 修改清除方法
function clearAuthData() {
  localStorage.removeItem("token");
  localStorage.removeItem("role"); // 新增
  sessionStorage.clear();
  const store = useStore();
  store.$reset();
}

export default router
